import React from "react";
import styled from "styled-components";
import Spinner from "../../../components/Spinner";
import { primaryColor } from "../../../constants/colors";

const PatientSelector = ({ defaultValue, patients, onChange, readOnly }) => {
  console.log({ patients });
  return (
    <Wrapper className="px-3 py-3">
      <p className="txt">Patient</p>
      {readOnly ? (
        <div className="bg-grey2 px-2 py-2 rounded  text-grey2">Myself</div>
      ) : (
        <select name="patient" id="" className="problemField bg-grey2 px-3 py-3 rounded" defaultValue={defaultValue} onChange={(e) => onChange(e.target.value)}>
          <option value={0}>Myself</option>
          {patients.map((patient) => (
            <option key={patient.id} value={patient.id}>
              {patient.fullname}
            </option>
          ))}
        </select>
      )}
    </Wrapper>
  );
};

export default PatientSelector;

const Wrapper = styled.div`
  .appointmenttype {
    overflow-x: scroll;
  }
  .problemField {
    width: 100%;

    outline: none;
    border: none;
  }

  .txt {
    color: gray;
  }

  p {
    margin-bottom: 0.4rem;
  }
`;
